import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import Link from '../../../../../components/ZUILib/Link';
import commonUtil from '../../../../../utils/commonUtil';
import AppEvents from '../../../../App/AppEvents';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const applicationRoutes = commonUtil.getApplicationRoutes();

class BonusDetailPage extends Component {
  componentDidMount() {
    if (channel === constChannels.WAP) {
      this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
      if (this.wapBackButtonEvent) {
        AppEvents.publish(this.wapBackButtonEvent, [() => {
          browserHistory.push(commonUtil.routeTo(applicationRoutes.accountStatus, { eventID: this.props.eventId }));
        }]);
      }
    }
  }
  componentWillUnmount() {
    AppEvents.unsubscribe(this.wapBackButtonEvent);
  }

  render() {
    this.eventId = this.props.eventId;
    const bonusDetailsData = this.props.bonusDetailsData.bonusDetails;

    const physicalInfo = this.props.bonusDetailsData.bonusDetails.physicalItemsBonusInfo;
    const electronicInfo = this.props.bonusDetailsData.bonusDetails.electronicItemsBonusInfo;
    const personalInfo = this.props.bonusDetailsData.bonusDetails.personalItemsBonusInfo;

    let bonusMessage = commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.message1');
    bonusMessage = bonusMessage.replace('{bonus}', bonusDetailsData.bonusPercentage).replace('{amount}',
      commonUtil.getCurrency(bonusDetailsData.totalBonusAmount));

    const PhysicalGiftPage = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.physicalGifts, { eventID: this.eventId }),
      className: 'lightLink size-Medium',
    };
    const PersonalPage = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.personalPurchases, { eventID: this.eventId }),
      className: 'lightLink size-Medium',
    };
    const electronicGiftsPage = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.electronicsGift, { eventID: this.eventId }),
      className: 'lightLink size-Medium',
    };


    return (
      <div className="mobileView">
        <div className="accountState">
          <div className="row">
            <div className="col-xs-12 pt-15">
              <p className="name">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label2')}</p>
            </div>
          </div>
          <div className="row pr-15 pl-15">
            {this.props.eventInfo.isEmployeeEvent ?
              <div className="col-xs-12 legend">
                <p>{bonusMessage}</p>
                <p>EL bono estará disponible hasta el cierre de tu mesa.</p>
              </div>
              :
              <div className="col-xs-12 legend">
                <p>{+bonusDetailsData.bonusPercentage}% {commonUtil.getLabel(this.props.lables.eventAccountStatement, 'accountStatement.bonus.message')}.</p>
                <p>EL bono estará disponible hasta el cierre de tu mesa.</p>
              </div>}
          </div>
          <div className="row pt-1 bt-1 bc-gray innerItem mt-5">
            <div className="col-xs-12">
              <p className="titleDescrip">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label4')}:</p>
            </div>
            <div className="col-xs-12 pr-0">
              <div className="td-91">
                <div className="col-xs-6 pl-0">
                  <p className="disponibility">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label5')}</p>
                </div>
                <div className="col-xs-6 text-right">
                  <p className="mont">{commonUtil.getCurrency(physicalInfo.totalBonusEligibleAmont)}</p>
                </div>
                <div className="col-xs-6 pl-0">
                  <p className="disponibility noValidate2">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label6')}</p>
                </div>
                <div className="col-xs-6 text-right">
                  <p className="mont noValidate2">{commonUtil.getCurrency(physicalInfo.totalAmountNotEligibleForBonus)}</p>
                </div>
              </div>
              <div className="td-3 text-right decorationLeft">
                <Link rrLink={PhysicalGiftPage} href={PhysicalGiftPage.href}><i className="icon-flecha_lightsvg_derecha" aria-hidden="true" /></Link>
              </div>
            </div>
          </div>
          <div className="row bgGray bonusTotal">
            <div className="col-xs-6 pr-0">
              <p>{+bonusDetailsData.bonusPercentage}% {commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label7')}:</p>
            </div>
            <div className="col-xs-5 text-right">
              <p>{commonUtil.getCurrency(physicalInfo.totalBonusAccumulated)}</p>
            </div>
          </div>
          <div className="row pt-1 bt-1 bc-gray innerItem">
            <div className="col-xs-12">
              <p className="titleDescrip">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label8')}:</p>
            </div>
            <div className="col-xs-12 pr-0">
              <div className="td-91">
                <div className="col-xs-6 pl-0">
                  <p className="disponibility">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label9')}</p>
                </div>
                <div className="col-xs-6 text-right">
                  <p className="mont">{commonUtil.getCurrency(personalInfo.totalBonusEligibleAmont)}</p>
                </div>
                <div className="col-xs-6 pl-0">
                  <p className="disponibility noValidate2">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label10')}</p>
                </div>
                <div className="col-xs-6 text-right">
                  <p className="mont noValidate2">{commonUtil.getCurrency(personalInfo.totalAmountNotEligibleForBonus)}</p>
                </div>
              </div>
              <div className="td-3 text-right decorationLeft">
                <Link rrLink={PersonalPage} href={PersonalPage.href}><i className="icon-flecha_lightsvg_derecha" aria-hidden="true" /></Link>
              </div>
            </div>
          </div>
          <div className="row bgGray bonusTotal">
            <div className="col-xs-6 pr-0">
              <p>{+bonusDetailsData.bonusPercentage}% {commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label11')}:</p>
            </div>
            <div className="col-xs-5 text-right">
              <p>{commonUtil.getCurrency(personalInfo.totalBonusAccumulated)}</p>
            </div>
          </div>
          <div className="row bc-gray innerItem mt-5">
            <div className="col-xs-12">
              <p className="titleDescrip">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label12')}</p>
            </div>
            <div className="col-xs-12 pr-0">
              <div className="td-91">
                <div className="col-xs-10 pl-0">
                  <p className="legend2">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label13')}</p>
                </div>
                <div className="col-xs-6 pl-0">
                  <p className="disponibility">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label15')}</p>
                </div>
                <div className="col-xs-6 text-right">
                  <p className="mont">{commonUtil.getCurrency(electronicInfo.totalBonusEligibleAmont)}</p>
                </div>
              </div>
              <div className="td-3 text-right decorationLeft">
                <Link rrLink={electronicGiftsPage} href={electronicGiftsPage.href}><i className="icon-flecha_lightsvg_derecha" aria-hidden="true" /></Link>
              </div>
            </div>
          </div>
          <div className="row bgGray bonusTotal">
            <div className="col-xs-6 pr-0">
              <p>{+bonusDetailsData.bonusPercentage}% {commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label14')}:</p>
            </div>
            <div className="col-xs-5 text-right">
              <p>{commonUtil.getCurrency(electronicInfo.totalBonusAccumulated)}</p>
            </div>
          </div>
          <div className="row bonusTotal">
            <div className="col-xs-6 pr-0">
              <p>Monto total válido para bono:</p>
            </div>
            <div className="col-xs-5 text-right">
              <p>{commonUtil.getCurrency(bonusDetailsData.totalBonusEligibleAmount)}</p>
            </div>
          </div>
          <div className="row bgGray aproximateBonusTotal">
            <div className="col-xs-6 pr-0">
              <p>{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label16')}:</p>
            </div>
            <div className="col-xs-5 text-right">
              <p>{commonUtil.getCurrency(bonusDetailsData.totalBonusAmount)}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BonusDetailPage;
